

import {

  FETCH_RAWITEMS_REQUEST,
  FETCH_RAWITEMS_SUCCESS,
  FETCH_RAWITEMS_FAILURE,

  CREATE_RAWITEM_REQUEST,
  CREATE_RAWITEM_SUCCESS,
  CREATE_RAWITEM_FAILURE,

  UPDATE_RAWITEM_REQUEST,
  UPDATE_RAWITEM_SUCCESS,
  UPDATE_RAWITEM_FAILURE,

  DELETE_RAWITEM_REQUEST,
  DELETE_RAWITEM_SUCCESS,
  DELETE_RAWITEM_FAILURE,
} from "./rawItemActionTypes";

const initialState = {
  userStockData: [],
  loading: false,
  error: null,
};

const rawItemReducer = (state = initialState, action) => {
  switch (action.type) {

    case FETCH_RAWITEMS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_RAWITEMS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        userStockData: action.payload.data,
      };
    case FETCH_RAWITEMS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        userStockData: [],
      };

    case CREATE_RAWITEM_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case CREATE_RAWITEM_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        userStockData: action.payload.data,
      };
    case CREATE_RAWITEM_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_RAWITEM_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case UPDATE_RAWITEM_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        userStockData: action.payload.data,
      };
    case UPDATE_RAWITEM_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_RAWITEM_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case DELETE_RAWITEM_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        userStockData: action.payload.data,
      };
    case DELETE_RAWITEM_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default rawItemReducer;
